import React from 'react';
import { motion } from 'framer-motion';
import { HandshakeIcon, TrendingUpIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
export function ManufacturerPartnerSection() {
  const benefits = [{
    icon: GlobeIcon,
    title: 'Regional Market Access',
    description: 'Established distribution channels across UAE, EU, and East Asia with verified business networks'
  }, {
    icon: TrendingUpIcon,
    title: 'Volume Commitments',
    description: 'Consistent bulk ordering with growing demand from enterprise and retail partners'
  }, {
    icon: ShieldCheckIcon,
    title: 'Brand Protection',
    description: 'Authorized distribution only, maintaining brand integrity and preventing counterfeits'
  }, {
    icon: HandshakeIcon,
    title: 'Long-term Partnership',
    description: 'Collaborative approach with marketing support and market feedback for product development'
  }];
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="manufacturers" className="py-20 px-6 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #0B1220 0%, #1e293b 100%)'
  }} data-id="element-191">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1552664730-d307ca884978?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-192" />
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-194">
          <div className="inline-block px-4 py-2 bg-[#3B82F6]/20 rounded-full text-[#3B82F6] text-sm font-semibold mb-4 border border-[#3B82F6]/30" data-id="element-195">
            For Manufacturers
          </div>
          <h2 className="text-4xl font-bold text-white mb-4" data-id="element-196">
            Partner With Us
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-197">
            Expand your reach in growing security hardware markets. We are
            actively seeking partnerships with manufacturers of hardware
            wallets, encrypted storage, secure phones, and privacy accessories.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-198">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all" data-id="element-199">
              <div className="w-12 h-12 bg-gradient-to-br from-[#3B82F6] to-[#10B981] rounded-lg flex items-center justify-center mb-4" data-id="element-200">
                <benefit.icon className="w-6 h-6 text-white" data-id="element-201" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-202">
                {benefit.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-203">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-204">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 max-w-3xl mx-auto" data-id="element-205">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-206">
              What We Are Looking For
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-207">
              We partner with manufacturers of hardware wallets, encrypted USB
              drives, secure mobile devices, RFID-blocking products, Faraday
              bags, and other privacy-focused hardware. If your products align
              with our mission of protecting digital freedom and privacy, we
              would love to hear from you.
            </p>
            <button onClick={scrollToContact} className="px-8 py-4 bg-gradient-to-r from-[#3B82F6] to-[#10B981] text-white rounded-xl text-lg font-semibold hover:shadow-lg hover:shadow-blue-500/50 transition-all hover:scale-105 inline-flex items-center gap-2" data-id="element-208">
              <HandshakeIcon className="w-5 h-5" data-id="element-209" />
              Submit Partnership Inquiry
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}